import gql from 'graphql-tag';

const GET_REGION_GROUPS_WITH_PRESET_LIST = gql`
  query getRegionGroupWithPresetList($orgId: String) {
    getRegionGroupWithPresetList(orgId: $orgId)
  }
`;

export default GET_REGION_GROUPS_WITH_PRESET_LIST;
